import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import getAuth from '../../../utils/api/getToken';
export interface Permission {
  area: string;
  permission: 'read' | 'read-write' | 'deny' | 'disabled';
  group: string | null;
}

export interface PermissionsResponse {
  email: string;
  groups: string[];
  permissions: Permission[];
}

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Permissions`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const permissionsApi = createApi({
  reducerPath: 'permissions',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getUserPermissions: builder.query<PermissionsResponse, void>({
      query: () => '/get-permissions'
    }),
  }),
});

export const { 
  useGetUserPermissionsQuery, 
  useLazyGetUserPermissionsQuery 
} = permissionsApi;